import { FiltersProvider } from "domain/Filters";
import { SortingProvider } from "domain/Sorting";
import { HistoryProvider } from "domain/History";
import { InvoicesProvider } from "domain/Invoice/context";
import { InventoryActionsProvider } from "./inventory.actions.context";

export const InventoryPageProvider = ({ children }) => (
  <SortingProvider>
    <FiltersProvider>
      <InvoicesProvider>
        <InventoryActionsProvider>
          <HistoryProvider loadHistories={false}>{children}</HistoryProvider>
        </InventoryActionsProvider>
      </InvoicesProvider>
    </FiltersProvider>
  </SortingProvider>
);
